(function(){
  var auto = ['.tr-section .tr-heading', '.tr-section .tr-sub', '.tr-product-card', '.tr-clin-card', '.tr-faq__item', '.tr-howto__step', '.tr-benefit-item', '.tr-power__stat', '.tr-review-item', '.tr-stack-table-wrap', '.tr-guarantee'];
  function tag(){
    auto.forEach(function(sel){
      document.querySelectorAll(sel).forEach(function(el, i){
        if(el.closest('.tr-shopbox__content') || el.closest('.tr-marquee') || el.classList.contains('cx-reveal') || el.closest('.cx-reveal')) return;
        el.classList.add('cx-reveal');
        var sib = el.parentElement ? Array.prototype.indexOf.call(el.parentElement.children, el) : 0;
        el.style.setProperty('--rd', Math.min(sib, 5) * 90 + 'ms');
      });
    });
  }
  function observe(){
    var els = document.querySelectorAll('.cx-reveal:not(.is-in)');
    if(!('IntersectionObserver' in window)){ els.forEach(function(e){ e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function(en){ en.forEach(function(x){ if(x.isIntersecting){ x.target.classList.add('is-in'); io.unobserve(x.target); } }); }, { rootMargin: '0px 0px -6% 0px' });
    els.forEach(function(e){ io.observe(e); });
  }
  function run(){ if(document.documentElement.classList.contains('shopify-design-mode')) return; tag(); observe(); }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  setTimeout(function(){ document.querySelectorAll('.cx-reveal:not(.is-in)').forEach(function(e){ var r = e.getBoundingClientRect(); if(r.top < innerHeight) e.classList.add('is-in'); }); }, 2500);
})();